var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._t("default",null,{"value":_vm.value_,"done":_vm.done})],2)}
var staticRenderFns = []

export { render, staticRenderFns }